import { render } from "./CvMaker-formEdit.vue?vue&type=template&id=5bfb7936"
import script from "./CvMaker-formEdit.vue?vue&type=script&lang=js"
export * from "./CvMaker-formEdit.vue?vue&type=script&lang=js"

import "./CvMaker-formEdit.vue?vue&type=style&index=0&id=5bfb7936&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__